import usePublicResource from './usePublicResource';

function useHoverMenu() {
  const { data } = usePublicResource('/hover-menu.json');
  return data;
}

export default useHoverMenu;
